// extracted by mini-css-extract-plugin
export default {"main":"Message_main__FUlN0","message":"Message_message__dKNyU","description":"Message_description__YpoWp","buttons":"Message_buttons__Kk+8q","button":"Message_button__Wz8Hy"};